module.exports = __webpack_public_path__ + "static/media/ic_check-pay-primary.4ac210b1.svg";